import React from "react";
import { IMAGES } from "../../lib/content";
import { HeroCopy, HeroCtas } from "../hero/HeroCopy";
import { HeroBadges, HeroStrip } from "../hero/HeroBadges";

export default function Hero({ t }) {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[92vh] md:min-h-[88vh] flex items-end overflow-hidden bg-brand-primary"
    >
      <img
        src={IMAGES.hero}
        alt="Roofing job in progress with new shingles and underlayment"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
        data-testid="hero-bg-image"
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative w-full max-w-7xl mx-auto px-5 md:px-8 lg:px-12 pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="max-w-3xl">
          <HeroCopy t={t} />
          <HeroCtas t={t} />
          <HeroBadges t={t} />
        </div>
      </div>

      <HeroStrip t={t} />
    </section>
  );
}
